module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_nordland_pos.2b99ad91.png";